import Inputmask from "inputmask";

window.addEventListener("load", function () {
    var phoneInput = $('.onboarding input[type="tel"]');
    if (phoneInput) {
        var im = new Inputmask("99 999 9999");
        im.mask(phoneInput);
    }

    var taxnumInput = $('.onboarding input[name="taxnum"]');
    if (taxnumInput) {
        var im = new Inputmask("99999999-9-99");
        im.mask(taxnumInput);
    }
});
